@import 'styles/mixins';
@import 'styles/variables';

.container {
  background-color: var(--modal-underlay-color);
  @include z-index(greaterThanSkeletons);
}

.v2 {
  .closeButton {
    width: 64px;
    justify-content: flex-end;
  }

  .footer {
    box-shadow: none;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .almanacLogo {
      width: 106.5px;
      height: 24px;

      * {
        fill: $gray-40;
      }
    }
  }
}

.header {
  display: flex;
  justify-content: space-between;
  @include lg-medium;
  color: $gray-90;
}

.headerContent {
  display: flex;
  align-items: center;
}

.body {
  max-width: 650px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.hero {
  width: 100%;
}

.content {
  max-width: 550px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 40px;
}

.title {
  @include header-md;
  color: $grey-90;
  margin-bottom: 4px;
}

.description {
  @include md-regular;
  color: $grey-40;
  margin-bottom: 0;
}

.primaryCta {
  margin-top: 32px;
}

.secondaryCta {
  @include btn-lg-text;
  color: $blue-50;
  padding: 8px 18px;
  margin-top: 8px;
}

.avatars {
  display: flex;
  align-items: center;
  margin-bottom: 28px;
  margin-top: 8px;
}

.faintAvatar {
  opacity: 0.5;
}

.avatarArrow {
  fill: $gray-40;
  margin-left: 6px;
  margin-right: 6px;
}

.leftArrow {
  transform: rotate(180deg);
}

.avatarsEmoji {
  margin-left: 8px;
  margin-right: 8px;
  font-size: 20px;
  color: #000;
}

.avatarRing {
  border-width: 2px;
  border-style: solid;
  border-radius: 50%;
  padding: 2px;
}

.hint {
  @include ui-sm-text;
  color: $gray-50;
  margin-top: 10px;
  margin-bottom: 0;
}

.footer {
  margin-top: 5px;
  padding: 16px 24px;
  width: 100%;
  box-shadow: inset 0px 1px 0px rgba(19, 21, 26, 0.12);
}
